export const twitterFollowButtonSpec = {
  content: '',
  group: 'block',
  marks: '',
  atom: true,
  attrs: {
    type: {
      default: 'twitterFollowButton'
    },
    username: {
      default: ''
    }
  },
  toDOM() {
    return ['div'];
  }
};